import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=8fcbc97a&"
import script from "./SocialLinks.vue?vue&type=script&lang=js&"
export * from "./SocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=8fcbc97a&prod&lang=scss&"
import style1 from "./SocialLinks.vue?vue&type=style&index=1&id=8fcbc97a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports